import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { css } from "styled-components";

filterListStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: #f5f4f4;
        padding: 0px 15px;
        h3 {
            margin: 0.5rem 0;
        }
    `,
};
